module.exports = __webpack_public_path__ + "img/logo.a03d3c7b.jpg";